import './CommentForm.scss';

export { default } from './CommentForm';
